window.onscroll = function () {
    var header = document.getElementById('header');
    var navLogo = document.getElementById('nav-logo');
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        if (header) {
            header.classList.add("scroll");
        }
        if (navLogo) {
            navLogo.classList.remove("col-3");
            navLogo.classList.add("col");
        }
    } else {
        if (header) {
            header.classList.remove("scroll");
        }
        if (navLogo) {
            navLogo.classList.remove("col");
            navLogo.classList.add("col-3");
        }
    }
};

window.onload = function () {
    var navbarNav = document.getElementById('navbarNav');
    if (navbarNav) {
        navbarNav.addEventListener('show.bs.collapse', function () {
            document.getElementById('header-logo').classList.add('d-none');
        });
        navbarNav.addEventListener('hide.bs.collapse', function () {
            document.getElementById('header-logo').classList.remove('d-none');
        });
    }
}
document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector('#header');
    if (header && (window.scrollY > 10 || window.pageYOffset > 10)) {
        header.classList.add('scroll');
    }
});

document.addEventListener("DOMContentLoaded", () => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
});

// Add offset anchor-links
document.addEventListener("DOMContentLoaded", () => {
    var header = document.querySelector('header');
    var headerHeight = (header ? header.offsetHeight : 0) + 50;

    document.querySelectorAll('a[href^="#"]')
        .forEach(function (anchor) {
            anchor.addEventListener('click',
                function (event) {
                    event.preventDefault();

                    var target = document.querySelector(
                        this.getAttribute('href')
                    );

                    var targetPosition = target
                        .getBoundingClientRect().top - headerHeight;

                    window.scrollTo({
                        top: targetPosition + window.pageYOffset,
                        behavior: 'smooth'
                    });
                });
        });
});